<template>
  <div class="login">
    <div class="loginTop">
      <div class="loginLogo warp">
        <div class="loginImgBox" @click="goToIndex">
          <img src="@/assets/images/dlogo.png" alt="" />
        </div>
        <span>欢迎登录</span>
      </div>
    </div>
    <div class="loginCent">
      <div class="loginBox warp">
        <div class="leftImg">
          <img src="@/assets/images/banner.png" alt="" />
        </div>
        <div class="loginForm">
          <div
            class="loginTit"
            v-text="isRegistered == '1' ? '注册' : '登录'"
          ></div>
          <div class="loginTab" v-if="isRegistered == '2'">
            <div :class="loginactive == 0 ? 'active' : ''" @click="loginTab(0)" style="cursor: pointer;">
              账号密码登录
            </div>
<!--            <div :class="loginactive == 1 ? 'active' : ''" @click="loginTab(1)" style="cursor: pointer;">-->
<!--              短信验证码登陆-->
<!--            </div>-->
          </div>
          <div class="loginFormBox" v-if="loginactive == 0">
            <div class="inputBox">
              <label>手机号码</label>
              <el-input
                v-model="userName"
                placeholder="请输入您的手机号码"
              ></el-input>
            </div>
            <div class="inputBox" style="position:relative;">
              <label>密码</label>
              <el-input
                type="password"
                v-model="password"
                value="123456"
                placeholder="请输入密码"
			        	@keyup.enter.native="login"
              ></el-input>
				      <a @click.prevent="forgetPwd" class="forgetPwd">忘记密码?</a>
            </div>
            <div class="noLogin" :class="{ registered: isRegistered === '1' }">
<!--              <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin"-->
<!--                >七天免登录</el-checkbox-->
<!--              >-->
              <span
                @click="registered"
                v-text="isRegistered === '1' ? '登录' : '用户注册'"
              ></span>
            </div>
            <div
              class="loginBtn"
              @click="login"
              v-text="isRegistered === '1' ? '注册' : '立即登录'"
            >
              立即登录
            </div>
          </div>

          <div class="loginFormBox" v-if="loginactive == 1">
            <div class="inputBox">
              <label>手机号码</label>
              <el-input
                v-model="userName"
                placeholder="请输入您的手机号码"
              ></el-input>
            </div>

<!--            <div class="inputBox">-->
<!--              <label>验证码</label>-->
<!--              <el-input-->
<!--                v-model="verificationCode"-->
<!--                placeholder="请输入验证码"-->
<!--              ></el-input>-->
<!--              <span v-show="codeShow" class="codeBtn" @click="getCode()"-->
<!--                >获取验证码</span-->
<!--              >-->
<!--              <span v-show="!codeShow" class="codeBtn codeCount"-->
<!--                >重新获取({{ codeCountNum }}s)</span-->
<!--              >-->
<!--            </div>-->

            <div class="inputBox" v-if="isRegistered === '1'">
              <label>输入密码</label>
              <el-input
                type="password"
                v-model="password1"
                placeholder="请输入密码"
                @keyup.enter.native="registered"
              ></el-input>
            </div>

            <div class="inputBox" v-if="isRegistered === '1'">
              <label>再次输入密码</label>
              <el-input
                type="password"
                v-model="password"
                placeholder="请输入密码" @keyup.enter.native="registered"
              ></el-input>
            </div>
            <!-- <div class="inputBox" v-if="isRegistered === '1'">
                <label>邀请码</label>
                <el-input v-model="inviteCode" placeholder="请输入邀请码"></el-input>
              </div> -->
            <div class="noLogin" :class="{ registered: isRegistered === '1' }">
<!--              <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin"-->
<!--                >七天免登录</el-checkbox-->
<!--              >-->
              <span
                @click="registered"
                v-text="isRegistered === '1' ? '登录' : '用户注册'"
              ></span>
            </div>
            <div
              class="loginBtn"
              @click="login"
              v-text="isRegistered === '1' ? '注册' : '立即登录'"
            >
              立即登录
            </div>

          </div>
<!--          &lt;!&ndash; qq 微信联合登录 &ndash;&gt;-->
<!--          <div v-if="isRegistered != '1'" style="text-align: center;padding-bottom: 10px;">-->
<!--            <div style="display: inline-block;margin-right: 10px;">-->
<!--              &lt;!&ndash; {{qqAuth}} &ndash;&gt;-->
<!--              <a target="_blank" @click="qqAuthM">-->
<!--                <img style="width: 40px;height: 40px;" src="../../../static/image/auth/QQ@2x.png" />-->
<!--                <br />-->
<!--                <span style="font-size: 0.8em;">QQ登录</span>-->
<!--              </a>-->
<!--            </div>-->
<!--            &lt;!&ndash; <div style="display: inline-block;margin-left: 10px;">-->
<!--              <a target="_blank" @click="wxAuthM">-->
<!--                <img style="width: 40px;height: 40px;" src="../../../static/image/auth/微信.png" />-->
<!--                <br />-->
<!--                <span style="font-size: 0.8em;">微信登录</span>-->
<!--              </a>-->
<!--            </div> &ndash;&gt;-->
<!--          </div>-->
          <div class="loginProtocol" v-if="isRegistered === '1'">
            <el-checkbox v-model="haveRead"></el-checkbox>
            <span>阅读并同意</span>
            <div style="flex: 2;display: flex;flex-wrap: wrap;line-height: 20px;padding-top: 30px;">
				      <span @click="readAgreement(item.id)" class="loginAgree" v-for="item in LoginAgreementsList" :key="item.id">{{item.title}}</span>
			      </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="服务协议" :visible.sync="dialogAgreement" width="50%">
      <div style="text-align: center;font-size: 18px;font-weight: 500;">{{title}}</div>
        <div v-html="content"></div>
      </el-dialog>
    <el-dialog
      title="忘记密码"
      :visible.sync="forgetPwdDialog"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form :model="forgetPwdForm" :rules="forgetPwdRules" ref="forgetPwdRef" label-width="100px" class="">
        <el-form-item label="手机号码" prop="phone">
            <el-input v-model="forgetPwdForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
<!--        <el-form-item label="验证码" prop="verificationCode" style="position: relative;">-->
<!--          <el-input v-model="forgetPwdForm.verificationCode" placeholder="请输入验证码" maxlength="6"></el-input>-->
<!--          <span v-if="codeShow" class="forgetCodeBtn" @click="getCode(true)">获取验证码</span>-->
<!--          <span v-else class="forgetCodeBtn codeCount" style="color: #999;">重新获取({{ codeCountNum }}s)</span>-->
<!--        </el-form-item>-->
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="forgetPwdForm.newPassword" placeholder="请输入密码" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="forgetPwdForm.confirmPassword" placeholder="请输入密码" type="password"></el-input>
        </el-form-item>
       </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirmUpdatePwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Cookie from "js-cookie";
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
import { mapMutations } from "vuex";
import md5 from 'js-md5';
let validatePhone = (rule,value,callback) => {
	let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
	if(!reg.test(value)) return callback('手机号码格式不正确')
	callback()
}

export default {
  name: "login",
  mixins: [listSearchMixin],
  data() {
    return {
      userName: "",
      password: "",
      password1 : "", //无作用
      verificationCode: "9999",
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: "",
      dialogAgreement: false,
      isRegistered: "2",
      loginactive: 0,
      inviteCode: "",
	  forgetPwdDialog: false,
	  forgetPwdForm: {
		  phone: '',
		  verificationCode: '9999',
		  newPassword: '',
		  confirmPassword: '',
      qqAuth:"",
	  },
	  forgetPwdRules: {
		  phone: [
			  { required: true, message: '请输入电话号码', trigger: 'blur' },
			  { validator: validatePhone, trigger: 'blur' }
		  ],
		  newPassword: [
			  { required: true, message: '请输入新密码', trigger: 'blur' },
			  { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
		  ],
		  verificationCode: [
			  { required: true, message: '请输入验证码', trigger: 'blur' }
		  ],
		  confirmPassword: [
			  { required: true, message: '请输入旧密码', trigger: 'blur' }
		  ]
	  },
	  LoginAgreementsList: [],
	  content: '',
	  title: ''
    };
  },
  created() {
    this.$nextTick(function(){
      this.qqAuth = api.qqAuth
    })
		this.getLoginAgreements()
  },
  mounted() {
    if (this.$route.query.type) {
      this.isRegistered = this.$route.query.type;
    }
  },
  methods: {
		getLoginAgreements(){
			let params = {
			  url: api.getLoginAgreements,
			  method: "get",
			  data: {
			  },
			}
			this.sendReq(params ,res => {
				this.LoginAgreementsList = res.data

			})
		},
    qqAuthM(){
      window.open(api.qqAuth);
    },
    wxAuthM(){
      window.open(api.wxAuth);
    },
    ...mapMutations({
      setUserInfo: "SET_USERINFO", // 修改用户信息
    }),
	//关闭dialog
	handleClose(){
		this.forgetPwdDialog = false
		this.$refs.forgetPwdRef.resetFields()
	},
	//确定修改密码
	confirmUpdatePwd(){
		this.$refs.forgetPwdRef.validate(valid => {
			if(!valid) return
			if(this.forgetPwdForm.newPassword != this.forgetPwdForm.confirmPassword) return this.$message.warning('密码不一致')
			let params = {
			  url: api.updateForgotPass,
			  method: "post",
			  data: {
				verificationCode: this.forgetPwdForm.verificationCode,
				phone: this.forgetPwdForm.phone,
				newPassword: md5(this.forgetPwdForm.newPassword),
				confirmPassword: md5(this.forgetPwdForm.confirmPassword)
			  },
			}
			this.sendReq(params,(res)=> {
				if(res.status == 200){
					this.$message.success('修改密码成功!')
					this.forgetPwdDialog = false
				}else {
					this.$message.error(res.msg)
				}
			})
		})
	},
	//忘记密码
	forgetPwd(){
		this.forgetPwdDialog = true
	},
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUser,
        method: "GET",
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.setUserInfo(res.data)
          self.userInfoData = res.data
        }
      });
    },
    getCode (flag) {
      if(flag) {
        this.userName = this.forgetPwdForm.phone
      }
      const TIME_COUNT = 60;
      let self = this;
      let reg = /^1[13456789]\d{9}$/;
      if (!reg.test(self.userName)) {
        self.$message.error("手机号格式错误");
        return;
      }
      let code="";
      if(self.isRegistered === "2" && this.loginactive == 1){
            code="login"
      }else{
         code="register"
      }
      let params = {
        url: api.vCode ,
        method: "POST",
        data: {
          phone: self.userName,
          type:flag ? 'login':code
        },
      };
      self.sendReq(params, (res) => {
        if (res.status === 200) {
          if (!this.timer) {
            this.codeCountNum = TIME_COUNT;
            this.codeShow = false;
            this.timer = setInterval(() => {
              if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
                this.codeCountNum--;
              } else {
                this.codeShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          this.$message({
            message: "验证码获取成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 阅读协议
    readAgreement(id) {
      this.dialogAgreement = true;
      this.sendReq({url:api.getLoginAgreementList+'/'+id,method:'get'},res => {
      this.content = res.data.content
      this.title = res.data.title
	  })
    },
    goToIndex() {
      this.$router.push({ path: "/" });
    },
    login() {
      let self = this;
      let reg = /^1[13456789]\d{9}$/;
      if (!reg.test(self.userName)) {
        self.$message({
          message: "手机号码格式错误",
        });
        return;
      }
      if (self.verificationCode === "" && self.isRegistered === "1") {
        self.$message({
          message: "请输入验证码",
        });
        return;
      }
	if(this.loginactive == 0){
		if (self.password === "") {
			self.$message({
			  message: "请输入密码",
			});
			return;
		  }
		if(self.password.length < 6 || self.password.length > 32){
		  self.$message({
			message: "密码长度为6-32位",
		  });
		  return;
		}
	}else {
		if(self.verificationCode === "" ){
			self.$message({
			  message: "请输入验证码",
			});
			return;
		}
	}

      if (self.isRegistered === "2") {
        this.getLogin();
      } else if (this.haveRead) {
        this.getLogin();
      } else {
        this.$message({
          message: "请阅读并同意服务协议",
        });
      }
    },
    getLogin() {
      let self = this;
      let params = {};
      if (self.isRegistered === "1") {
        params = {
          url: api.register,
          method: "post",
          status: "resgit",
          data: {
            // phone: self.userName,
            // verificationCode: self.verificationCode,
            // type: self.isRegistered
            account: self.userName,
            captcha: self.verificationCode,
            password: md5(self.password),
            inviteCode: self.inviteCode || "",
            spread: Cookie.get("spread") || "",
          },
        };
      } else if (self.isRegistered === "2" && this.loginactive == 0) {
        params = {
          url: api.login,
          method: "post",
          data: {
            username: self.userName,
            password: md5(self.password),
            spread: Cookie.get("spread") || "",
          },
        };
      } else if (self.isRegistered === "2" && this.loginactive == 1) {
        params = {
          url: api.loginByPhone,
          method: "post",
          data: {
            username: self.userName,
            captcha: self.verificationCode,
            type: self.isRegistered,
          },
        };
      }

      self.sendReq(params, (res) => {

        if (res.status === 200) {
          if (self.isNoLogin) {
            Cookie.set("token", res.data.token, { expires: 7 });
          } else {
            Cookie.set("token", res.data.token, { expires: 1 });
          }
          this.getUserInfo();
          if (params.status == "resgit") {
            this.$message({
              message: "注册成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "登陆成功",
              type: "success",
            });
            this.$router.push({ path: "/" });
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    registered() {
      this.codeShow = true;
      clearInterval(this.timer);
      this.timer = null;
      this.userName = "";
      this.verificationCode = "9999";
      if (this.isRegistered === "1") {
        this.isRegistered = "2";
        this.loginactive = 0;
      } else {
        this.isRegistered = "1";
        this.loginactive = 1;
      }
    },
    loginTab(index) {
      this.loginactive = index;
    },
  },
};
</script>

<style lang="scss" scoped>
	.forgetCodeBtn {
		padding: 0 10px;
		background: #eeeeee;
		border-radius: 4px;
		font-size: 12px;
		position: absolute;
		right: 0;
		cursor: pointer;
		color: #000;
	}
	.forgetPwd {
		position: absolute;
		right: 5px;
		top: 42px;
		font-size: 12px;
		color: #f9bc84;
	}
.login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 768px;
  .loginTop {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 999;
    flex-shrink: 0;
    .loginLogo {
      display: flex;
      align-items: center;
      height: 88px;
      img {
        width: 180px;
        margin-right: 30px;
      }
      span {
        font-size: 18px;
        color: $fontColor;
      }
      .loginImgBox {
        width: 200px;
        height: 40px;
        align-items: center;
        display: flex;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
  }
  .loginCent {
    background-color:#faf7f5;
    flex-grow: 1;
    background-size: cover;
    display: flex;
    align-items: center;
    .loginBox {
      display: flex;
      align-items: center;
      position: relative;
    }
    .leftImg {
      width: 760px;
      height: 490px;
    }
    .loginForm {
      width: 540px;
      background: #ffffff;
      box-shadow: 0px 15px 14px 2px rgba(162, 87, 20, 0.15);
      border-radius: 20px;
      position: absolute;
      right: 0;
      .loginTit {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 30px;
        color: $mainColor;
        width: 100%;
        justify-content: center;
        margin: 70px 0;
        &:before {
          content: "";
          height: 2px;
          width: 98px;
          display: block;
          background: url("../../assets/images/dzuo.png") no-repeat;
          margin-right: 27px;
        }
        &:after {
          content: "";
          height: 2px;
          width: 98px;
          display: block;
          background: url("../../assets/images/dyou.png") no-repeat;
          margin-left: 27px;
        }
      }
      .loginTab {
        height: 50px;
        display: flex;
        align-items: flex-start;
        font-size: 15px;
        color: #000;
        justify-content: space-between;
        flex-direction: row;
        padding: 0 25%;
        .active {
          color: $mainColor;
          position: relative;
        }
        // .active::after{
        //   position: absolute;
        //   bottom: -6px;
        //   left: 72px;
        //   right: 72px;
        //   height: 4px;
        //   content: '';
        //   background: $mainColor;
        //   border-radius: 2px;
        // }
      }
      .loginFormBox {
        padding: 0 60px;
        .inputBox {
          position: relative;
          label {
            color: $fontColor;
            font-size: 18px;
            font-weight: 500;
          }
          >>> .el-input__inner {
            height: 64px;
            border: none;
            border-bottom: 1px solid #eeeeee;
            font-size: 20px;
            color: #666666;
            padding-left: 0;
          }
          &:nth-child(2) {
            margin: 60px 0 20px 0;
          }
          .codeBtn {
            width: 140px;
            height: 54px;
            background: #eeeeee;
            border-radius: 4px;
            display: block;
            line-height: 54px;
            text-align: center;
            position: absolute;
            right: 0;
            bottom: 10px;
            cursor: pointer;
          }
          .codeCount {
            color: #999999;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          margin: 20px 0 60px 0;
          height: 30px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            text-decoration: underline;
            color: #666666;
          }
        }
        .registered {
          justify-content: flex-end;
        }
        .loginBtn {
          width: 100%;
          background: $mainColor;
          height: 60px;
          line-height: 60px;
          border-radius: 27px;
          text-align: center;
          font-size: 20px;
          color: #ffffff;
          // margin-bottom: 60px;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
      .loginProtocol {
        padding: 0 60px;
        display: flex;
        // align-items: center;
        height: 80px;
        line-height: 80px;
        border-top: 1px solid #eeeeee;
        span {
          margin-left: 10px;
        }
		.loginAgree{
			width: 45%;
			font-size: 15px;
			color: #426bea;
			cursor: pointer;
		}
		.loginAgree:hover {
			color: #2b72ff;
		}
        // span:nth-child(3) {
        //   color: #426bea;
        //   cursor: pointer;
        // }
      }
      >>> .el-checkbox__inner {
        width: 20px;
        height: 20px;
        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }
  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue